import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useTranslation from '../../../../modules/i18n/useTranslation'

interface FooterNavProps {
  title: string
  items: { name: string[]; link: string }[]
}

const FooterNav = ({ title, items }: FooterNavProps) => {
  const { t } = useTranslation()
  const router = useAppRouter()

  const handleNavClick = (link) => {
    if (link.startsWith('http')) {
      window.open(link, '_blank')
      return
    }

    router.push(link)
  }

  return (
    <div className="flex flex-col gap-y-16">
      <span className="Body1-16Bd text-gray-700">{title}</span>
      <ul className="flex flex-col gap-y-16">
        {items.map((item, index) => (
          <li key={index} className="Body2-14Md text-gray-500">
            <button onClick={() => handleNavClick(item.link)}>{t(item.name)}</button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default FooterNav
